import { useState } from 'react';
import { 
  Upload, 
  FolderPlus, 
  Grid, 
  List,
  File,
  MoreVertical,
  ChevronRight
} from 'lucide-react';
import { formatFileSize, formatDate } from '../../utils/format';

const files = [
  { 
    id: '1', 
    name: '项目文档.docx', 
    size: 1024 * 1024 * 2.5,
    modified: '2024-03-10T10:30:00',
    type: 'document'
  },
  { 
    id: '2', 
    name: '设计稿.psd',
    size: 1024 * 1024 * 15,
    modified: '2024-03-09T16:45:00',
    type: 'image'
  }
];

export default function CloudManagement() {
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('list');

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">云盘管理</h1>
        <div className="flex items-center space-x-4">
          <button className="btn-primary flex items-center space-x-2">
            <Upload className="w-4 h-4" />
            <span>上传文件</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <FolderPlus className="w-4 h-4" />
            <span>新建文件夹</span>
          </button>
          <div className="border-l pl-4 flex items-center space-x-2">
            <button 
              onClick={() => setViewMode('grid')}
              className={`p-2 rounded ${viewMode === 'grid' ? 'bg-gray-100' : 'hover:bg-gray-50'}`}
            >
              <Grid className="w-5 h-5" />
            </button>
            <button 
              onClick={() => setViewMode('list')}
              className={`p-2 rounded ${viewMode === 'list' ? 'bg-gray-100' : 'hover:bg-gray-50'}`}
            >
              <List className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm">
        {/* 面包屑导航 */}
        <div className="px-6 py-4 border-b flex items-center space-x-2 text-sm">
          <button className="text-gray-500 hover:text-gray-700">根目录</button>
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <button className="text-gray-500 hover:text-gray-700">文档</button>
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <span className="text-gray-900">工作</span>
        </div>

        {viewMode === 'list' ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    名称
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    修改时间
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    大小
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
                    操作
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {files.map((file) => (
                  <tr key={file.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <File className="w-5 h-5 text-gray-400 mr-3" />
                        <span className="text-sm text-gray-900">{file.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {formatDate(file.modified)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {formatFileSize(file.size)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm">
                      <button className="text-gray-400 hover:text-gray-500">
                        <MoreVertical className="w-5 h-5" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {files.map((file) => (
              <div 
                key={file.id}
                className="group relative p-4 rounded-lg border hover:shadow-md transition-shadow"
              >
                <div className="flex flex-col items-center">
                  <File className="w-12 h-12 text-gray-400 mb-2" />
                  <span className="text-sm text-center text-gray-900 truncate w-full">
                    {file.name}
                  </span>
                  <span className="text-xs text-gray-500">
                    {formatFileSize(file.size)}
                  </span>
                </div>
                
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button className="p-1 hover:bg-gray-100 rounded">
                    <MoreVertical className="w-4 h-4 text-gray-500" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}